import clsx from 'clsx';

import styles from '@web/molecules/VideoPlayer/VideoPlayer.module.scss';
import type { VideoPlayerWrapperProps } from '@web/molecules/VideoPlayer/VideoPlayer.types';

type Props = VideoPlayerWrapperProps;

export const HorizontalWrapper = ({ children, allowSharing, isPlayingAd }: Props) => {
    return (
        <div
            className={clsx(
                styles['player-horizontal'],
                !allowSharing && styles['player-horizontal--sharing-disabled'],
                isPlayingAd ? styles['player-horizontal--ad-mode'] : styles['player-horizontal--video-mode'],
                'inverted',
            )}
        >
            {children}
        </div>
    );
};
